import { StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { ticketColors } from '../../../shared/theme/ticketColors'
import { typography } from '../../../shared/theme/typography';
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: ticketColors.counter,
  },
  containerEmbedded: {
    flex: 1,
    minHeight: 0,
    backgroundColor: 'transparent',
  },
  containerWide: {
    flexDirection: 'row',
  },
  containerCompact: {
    flexDirection: 'column',
  },
  csvToolbar: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.xs,
  },
  csvToolbarButton: {
    alignSelf: 'flex-start',
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: 'transparent',
  },
  csvToolbarButtonText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  scroll: {
    flex: 1,
    minHeight: 0,
  },
  scrollContent: {
    padding: spacing.lg,
    paddingBottom: spacing.xxl,
    gap: spacing.lg,
  },
  scrollContentCompact: {
    padding: spacing.md,
    paddingBottom: spacing.xxl,
    gap: spacing.md,
  },
  // Sidebar (web/desktop)
  sidebar: {
    width: 176,
    borderRightWidth: 1,
    borderRightColor: ticketColors.ruleSoft,
    paddingVertical: 18,
    paddingHorizontal: 12,
    backgroundColor: ticketColors.paper2,
  },
  sidebarTitle: {
    ...typography.title3,
    color: ticketColors.ink,
    paddingHorizontal: 10,
    paddingBottom: 12,
  },
  sidebarCaption: {
    fontSize: 11,
    fontWeight: '800',
    letterSpacing: 0.7,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    paddingHorizontal: 10,
    paddingBottom: 10,
  },
  sidebarNav: {
    gap: 4,
  },
  sidebarItem: {
    minHeight: 40,
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'transparent',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  sidebarItemActive: {
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
  },
  sidebarItemAccent: {
    width: 0,
    height: 0,
  },
  sidebarItemAccentHidden: {
    opacity: 0,
  },
  sidebarItemText: {
    flex: 1,
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink2,
  },
  sidebarItemTextActive: {
    color: ticketColors.brandInk,
  },
  sidebarCount: {
    minWidth: 24,
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 999,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    alignItems: 'center',
  },
  sidebarCountActive: {
    backgroundColor: ticketColors.paper,
    borderColor: 'transparent',
  },
  sidebarCountText: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontSize: 12,
    fontWeight: '800',
  },
  sidebarCountTextActive: {
    color: ticketColors.brandInk,
  },
  sidebarBadge: {
    marginLeft: 'auto',
    minWidth: 24,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 999,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
  },
  sidebarBadgeActive: {
    backgroundColor: ticketColors.gold,
  },
  sidebarBadgeText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
  },
  sidebarBadgeTextActive: {
    color: ticketColors.goldInk,
  },
  // Tabs (mobile)
  tabsRow: {
    flexGrow: 0,
    backgroundColor: 'transparent',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
  },
  tabsRowContent: {
    flexDirection: 'row',
    paddingHorizontal: 14,
    paddingTop: 4,
    paddingBottom: 10,
    gap: 8,
  },
  tabChip: {
    height: 40,
    paddingHorizontal: 14,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
  },
  tabChipSelected: {
    backgroundColor: ticketColors.brandPrimary,
    borderColor: ticketColors.brandPrimary,
  },
  tabChipText: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink2,
  },
  tabChipTextSelected: {
    color: ticketColors.goldInk,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
    marginBottom: spacing.xs,
  },
  sectionHeaderText: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  sectionDescription: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  sectionContext: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
    paddingTop: 5,
    flexShrink: 0,
  },
  sectionDot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    backgroundColor: ticketColors.ok,
  },
  sectionDotMuted: {
    backgroundColor: ticketColors.ink3,
  },
  sectionContextText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
  },
  readOnlyNotice: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingHorizontal: spacing.md,
    paddingVertical: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    backgroundColor: ticketColors.warnBg,
  },
  readOnlyNoticeText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  // Section hero
  sectionHero: {
    gap: spacing.md,
  },
  sectionHeroMain: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
  },
  sectionHeroIcon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  sectionHeroText: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  sectionHeroActions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 7,
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  sectionTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
  },
  sectionSubtitle: {
    ...typography.caption,
    color: ticketColors.ink2,
    marginTop: 2,
  },
  primaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    backgroundColor: ticketColors.brandPrimary,
    paddingVertical: spacing.sm + 2,
    paddingHorizontal: spacing.lg,
    borderRadius: 10,
    minHeight: 44,
  },
  primaryButtonIconOnly: {
    width: 44,
    minWidth: 44,
    paddingHorizontal: 0,
    borderRadius: 10,
    minHeight: 44,
  },
  primaryButtonText: {
    ...typography.caption,
    color: ticketColors.goldInk,
    fontWeight: '800',
  },
  secondaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    backgroundColor: ticketColors.paper2,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    minHeight: 44,
  },
  secondaryButtonText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  dangerButton: {
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: 'rgba(185,28,28,0.28)',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    alignItems: 'center',
    minHeight: 40,
    justifyContent: 'center',
  },
  dangerButtonText: {
    ...typography.caption,
    color: ticketColors.bad,
    fontWeight: '700',
  },
  // Lista
  listHeadingRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    gap: spacing.sm,
  },
  listHeadingTitle: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: 0.35,
  },
  listHeadingHint: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '600',
  },
  listEmpty: {
    ...ticketSurfaces.paperSheet,
    paddingVertical: spacing.xl,
    paddingHorizontal: spacing.lg,
    alignItems: 'center',
    gap: spacing.sm,
  },
  listEmptyIconWrap: {
    width: 52,
    height: 52,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  listEmptyCta: {
    marginTop: spacing.xs,
    paddingHorizontal: spacing.lg,
  },
  listEmptyTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  listEmptyText: {
    ...typography.caption,
    color: ticketColors.ink2,
    textAlign: 'center',
  },
  itemCardBody: {
    gap: spacing.xs,
  },
  itemCardBodyWide: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: spacing.xs,
    gap: spacing.lg,
  },
  itemCardContent: {
    flex: 1,
    gap: spacing.xs,
  },
  itemCardActions: {
    flexDirection: 'row',
    gap: spacing.xs,
    alignItems: 'center',
  },
  itemCardWrapInactive: {
    opacity: 0.55,
  },
  itemHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  itemTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    flexShrink: 1,
  },
  itemMeta: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    lineHeight: 18,
  },
  badge: {
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
    borderRadius: 999,
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  badgeText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
  },
  badgeInactive: {
    backgroundColor: 'rgba(185, 28, 28, 0.10)',
    borderColor: ticketColors.bad,
  },
  badgeInactiveText: {
    color: ticketColors.bad,
  },
  itemActions: {
    flexDirection: 'row',
    gap: spacing.xs,
    flexWrap: 'wrap',
    marginTop: spacing.xs,
  },
  // Form embebido — superficie compartida con settings (`settingsStyles.card`)
  formLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  formField: {
    gap: spacing.xs,
  },
  formInput: {
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm + 2,
    color: ticketColors.ink,
    minHeight: 44,
    ...typography.body,
  },
  formInputError: {
    borderColor: ticketColors.bad,
  },
  formFieldError: {
    ...typography.caption,
    color: ticketColors.bad,
  },
  formActions: {
    flexDirection: 'row',
    gap: spacing.sm,
    flexWrap: 'wrap',
  },
  formPanelShell: {
    ...ticketSurfaces.paperSheet,
    gap: 0,
  },
  formPanelHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm + 2,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    backgroundColor: ticketColors.paper2,
  },
  formPanelTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '800',
    flex: 1,
  },
  formPanelCloseBtn: {
    width: 44,
    height: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  formPanelBody: {
    marginTop: 0,
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: ticketColors.paper,
  },
  formPanelFooter: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    padding: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    backgroundColor: ticketColors.paper2,
  },
  formPanelPrimaryBtn: {
    flexGrow: 1,
    minWidth: 140,
  },
  formPanelSecondaryBtn: {
    minWidth: 120,
  },
  optionChipRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  optionChip: {
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    minHeight: 40,
    justifyContent: 'center',
  },
  optionChipSelected: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
  },
  optionChipText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
  },
  optionChipTextSelected: {
    color: ticketColors.goldInk,
  },
  // Layout PC - Grid de items
  itemGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 0,
  },
  itemGridItem: {
    flexBasis: '48%',
    flexGrow: 1,
    minWidth: 300,
  },
  // Layout PC - Form en columnas
  formRow: {
    flexDirection: 'row',
    gap: spacing.md,
  },
  formColumn: {
    flex: 1,
    gap: spacing.md,
  },
  // Layout PC - Header compacto
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
  },
  headerFilters: {
    flexDirection: 'row',
    gap: spacing.xs,
  },
  headerSearch: {
    flex: 1,
    maxWidth: 400,
  },
});
